<template>
    <div class="footer-home" v-if="$route.name == 'home' || $route.name == 'waiting'">
      <a v-if="this.locale != 'ES_es'" href="mailto:contact@mypromodistrigo.com">Contact</a>
      <a v-if="this.locale == 'ES_es'" href="mailto:contact@euroreparpromo.com">Contact</a>
    </div>
</template>


<script>
import i18n from '../lib/i18n';

export default {
  name: 'Footer',
  mixins:[i18n.mixin],
  data: function () {
    return {
        locale :'FR-fr'
    }
  }
}
</script>